import React from 'react';
import { Box } from '@mui/material';
import '../motion/motion.css';

const LINES = [96, 88, 92, 58];

export default function AiThinking() {
  return (
    <Box data-testid="ai-thinking" sx={{ py: 0.5 }}>
      <span className="svx-thinking" aria-hidden="true">Thinking...</span>
      <span className="svx-sr" role="status">Thinking</span>
      <Box className="svx-skel" aria-hidden="true" sx={{ mt: 1 }}>
        {LINES.map((w) => <span key={w} className="svx-skel__line" style={{ width: `${w}%` }} />)}
      </Box>
    </Box>
  );
}
